
import React from 'react';
import { ArrowRight, ShieldCheck, Zap } from 'lucide-react';
import { Translation } from '../types';

interface HeroProps {
  t: Translation['hero'];
}

export const Hero: React.FC<HeroProps> = ({ t }) => {
  return (
    <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden">
      
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-blue-600/20 rounded-full blur-[128px]"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-purple-600/20 rounded-full blur-[128px]"></div>
        <div className="absolute top-[40%] left-[20%] w-[300px] h-[300px] bg-cyan-500/10 rounded-full blur-[96px]"></div>
      </div>

      <div className="container mx-auto px-4 text-center">
        
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700 backdrop-blur-sm mb-8 animate-fade-in-up">
          <ShieldCheck className="text-green-400" size={16} />
          <span className="text-slate-300 text-sm font-medium">{t.secureBadge}</span>
        </div>

        {/* Primary SEO Heading (H1) */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-100 to-slate-400 mb-6 leading-tight max-w-5xl mx-auto tracking-tight">
          {t.title}
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-slate-400 mb-10 max-w-3xl mx-auto leading-relaxed">
          {t.subtitle}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="https://t.me/ksiuiwi552" 
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 bg-blue-600 hover:bg-blue-500 text-white rounded-xl font-bold text-lg transition-all shadow-[0_0_20px_rgba(37,99,235,0.3)] hover:shadow-[0_0_30px_rgba(37,99,235,0.5)] w-full sm:w-auto"
          >
            <span>{t.cta}</span>
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </a>
          
          <a 
            href="#products" 
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-slate-800 hover:bg-slate-700 border border-slate-700 text-slate-200 rounded-xl font-semibold text-lg transition-all w-full sm:w-auto"
          >
            <Zap size={20} className="text-yellow-400" />
            <span>Browse Cloud Products</span>
          </a>
        </div>

      </div>
    </section>
  );
};

